import React from 'react';
import { Grid } from '@mui/material';
import { TextHeader, styleSeparator } from './style';

export default function Header({ children }) {
  return (
    <Grid container spacing={0} alignItems="center">
      <Grid item xs={5.5} style={{ textAlign: 'center' }}>
        <TextHeader>{children[0]}</TextHeader>
      </Grid>
      <Grid item xs={1} style={styleSeparator}>
        |
      </Grid>
      <Grid item xs={5.5} style={{ textAlign: 'center' }}>
        <TextHeader>{children[1]}</TextHeader>
      </Grid>
    </Grid>
  );
}
